import { fromJS, Map } from 'immutable';

import { parse as parseRoute } from '../../../utils/route';

export function setRoute(state, action) {
    let route = parseRoute(action.route);

    let value = route.value === null ? null : fromJS({
        value: route.value,
        parameters: action.data || Map()
    });

    return state.set(route.name, value);
}
